import React from 'react';
import Card from '../../controls/Card';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FaHashtag, FaTicketAlt, FaUserMd, FaGraduationCap, FaRegCalendarAlt } from 'react-icons/fa';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import StatusContainer from '../../controls/StatusContainer';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';

const MyConfirmCard = ({ item }) => {
    return (
        <Link to={'/checkconfirmed/' + item.id}>
            <Card
                title={
                    <div className="w-full flex items-center gap-3">
                        {/* Compact Tonal Avatar */}
                        <div className="w-10 h-10 sm:w-12 sm:h-12 shrink-0 rounded-xl bg-indigo-100 flex items-center justify-center text-indigo-700 text-sm sm:text-base font-bold">
                            {item.patientName.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                        </div>
                        <div className="w-full min-w-0">
                            <div className="flex items-center justify-between gap-2">
                                <h3 className="text-sm sm:text-base font-bold text-slate-900 truncate">
                                    {item.patientName}
                                </h3>
                                <StatusContainer
                                    bg={EOPDConfirmedStatusBg(item.status)}
                                    text={GetEOPDConfirmedStatusName(item.status)}
                                />
                            </div>
                            {/* Meta row: ID, OPD No, Date — sab ek hi line me, wrap ho jata hai */}
                            <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px] sm:text-xs text-slate-500 font-medium mt-1">
                                <span className="flex items-center gap-1">
                                    <FaHashtag className="w-2.5 h-2.5 shrink-0" />
                                    {item.id}
                                </span>
                                <span className="flex items-center gap-1 text-green-600">
                                    <FaTicketAlt className="w-2.5 h-2.5 shrink-0" />
                                    OPD: {item.confirmedAllotedNumber}
                                </span>
                                <span className="flex items-center gap-1">
                                    <FaRegCalendarAlt className="w-2.5 h-2.5 shrink-0" />
                                    {moment(item.onDate).format("MMM DD, YYYY")}
                                </span>
                            </div>
                        </div>
                    </div>
                }
                isBorder={true}
            >
                {/* Compact info rows — no boxes, just divided rows */}
                <div className="divide-y divide-slate-100 text-xs sm:text-sm">
                    <div className="flex items-center justify-between gap-2 py-1.5">
                        <span className="flex items-center gap-1.5 text-slate-500 shrink-0">
                            <FaUserMd className="w-3 h-3" />
                            Doctor
                        </span>
                        <span className="font-medium text-slate-800 text-right truncate">
                            {item.user.fullName}{' '}
                            <span className="font-normal text-slate-500">{item.user.degree}</span>
                        </span>
                    </div>
                    <div className="flex items-center justify-between gap-2 py-1.5">
                        <span className="flex items-center gap-1.5 text-slate-500 shrink-0">
                            <FaGraduationCap className="w-3 h-3" />
                            Specialisation
                        </span>
                        <span className="font-medium text-slate-800 text-right truncate">
                            {item.user.specialisation.name}
                        </span>
                    </div>
                    <div className="flex items-center justify-between gap-2 py-1.5">
                        <span className="flex items-center gap-1.5 text-slate-500 shrink-0">
                            <HiOutlineBuildingOffice2 className="w-3.5 h-3.5" />
                            Opd Center
                        </span>
                        <span className="font-medium text-slate-800 text-right truncate">
                            {item.opdCenter.centerName}
                        </span>
                    </div>
                </div>
            </Card>
        </Link>
    );
};

export default MyConfirmCard;